
import React from "react";
import TextInput from "../../../common/TextInput";
import JaNeeRadioButtonGroup from "../../../common/JaNeeRadioButtonGroup";
import Fieldset from "../../../common/Fieldset";
import PropTypes from "prop-types";

const KinderenComponent = props => {
	const { model, disabled, onChange, getError, validationMessageType } = props;


	return <Fieldset title={"Geschikt voor kinderen jonger dan 12 jaar "}>
		<JaNeeRadioButtonGroup
			label="Een of meerdere routes geschikt voor kinderen jonger dan 12 jaar"
			name="toegankelijkheidVoorKinderen"
			value={model.toegankelijkheidVoorKinderen}
			labelInside
			onChange={onChange}
			horizontal
			disabled={disabled}
			size={12}
			validationMessage={getError("toegankelijkheidVoorKinderen")}
			validationMessageType={validationMessageType}
		/>
		{model.toegankelijkheidVoorKinderen === true || model.toegankelijkheidVoorKinderen === "true" ?
			<TextInput
				label="Beschrijf welke route geschikt is voor kinderen jonger dan 12 jaar"
				name="beschrijvingToegankelijkheidKinderen"
				size={12}
				value={model.beschrijvingToegankelijkheidKinderen}
				onChange={onChange}
				validationMessage={getError("beschrijvingToegankelijkheidKinderen")}
				validationMessageType={validationMessageType}
				disabled={disabled}
			/> : null}
	</Fieldset>;
};

KinderenComponent.propTypes = {
	model: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	getError: PropTypes.func.isRequired,
	validationMessageType: PropTypes.string
};

export default KinderenComponent;
